import React, { useState } from 'react'
import styles from './review.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import { CustomButton } from '../../../../../shared/customButton';
import { createQuizTemplate } from '../../../../../../services/util/quizTemplates';
import { useNavigate } from 'react-router-dom';


const Review = (props) => {

    const [state, setState] = useState(false);
    const history = useNavigate();

    const submitDetails = async () => {
        setState(true)
        let response = await createQuizTemplate(props.values.quizName, props.values.quizSpecialization, props.values.subject_areas, props.values.duration, props.values.Description);
        if (response.success == true) {
            setState(false);
            history(`/company/quiz-templates/${response.data.quiz_template_id}`)
            props.handleClose();
        }
        else {
            setState(false)
        }
    }

    return (
        <div>
            <Container>
                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Quiz&nbsp;Name&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_quizNameReviewId">
                            {props.values.quizName}
                        </span>
                    </Col>
                </Row>
                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Quiz&nbsp;Specialization&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_quizSpecializationReviewId">
                            {props.values.quizSpecialization}
                        </span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Subject&nbsp;Areas&nbsp;:</span><br />
                        <span className={styles.rowValues}>
                            {props.values.subject_areas.map((value, index) => (
                                <p className="mb-1" key={index} id={`adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_addedSubjectAreasReviewId.${index}`}><i className="fas fa-circle"></i>&nbsp;{value}</p>
                            ))
                            }
                        </span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Quiz&nbsp;Time&nbsp;Period&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_addedQuizTimeReviewId">
                            {props.values.duration}
                        </span>
                    </Col>
                </Row>
                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Description&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_addedDescriptionReviewId">
                            {props.values.Description}
                        </span>
                    </Col>
                </Row>

                <Row className={styles.actionBtns}>
                    <Col className="ps-0">
                        {<CustomButton
                            buttonType="submit"
                            label="Back"
                            type="defaultBtn"
                            handleClick={() => props.previousPage(1)}

                        />}
                    </Col>
                    <Col className="pe-0">
                        {<CustomButton
                            buttonType="submit"
                            label="Submit"
                            id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_reviewSubmitBtnId"
                            type="primaryBtn"
                            disabled={state === true ? true : false}
                            backicon={
                                state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    : ''
                            }
                            handleClick={() => submitDetails()}
                        />}
                    </Col>
                </Row>

            </Container>
        </div>
    )
}

export default Review
